// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// used when POSTing a new path to API.
// if the sites do not have a default contact/company
// assigned, the project's default contact/company will
// be passed down to the new segment end(s)

const assignDefaultContactToSite = ({ segments }, defaultCompany, defaultContact) => {
  const companyId = (
    defaultCompany
      ? defaultCompany.get('companyId')
      : null
  )
  const contactId = (
    defaultContact
      ? defaultContact.get('contactId')
      : null
  )

  segments.map(s => {
    s.segmentEnds.map(se => {
      if (!se.companyId && !se.contactId) {
        se.companyId = companyId
        se.contactId = contactId
      }
    })
  })
}

export default assignDefaultContactToSite
